import React from 'react';
import { Button } from '@amzn/stencil-react-components/button';
import { Row } from '@amzn/stencil-react-components/layout';
import { Text } from '@amzn/stencil-react-components/text';
import {unSubscribedMessages} from "../localeContent";
import { getLocalePreference } from "../../util/getLocalePreference";

const Headline = Text.withComponent('h1');
const localePreference = getLocalePreference();
const content = JSON.parse(JSON.stringify(unSubscribedMessages))[localePreference];

export type UnsubscribedStateProps = {
    onClickSubscribe: () => void;
};
export default function UnsubscribedState(props: UnsubscribedStateProps) {
    return (
        <div>
            <Row alignItems="center" justifyContent="center">
                <Headline fontSize="T600">{content.headline}</Headline>
            </Row>
            <Row alignItems="center" justifyContent="center" margin="1rem">
                <Text fontSize="T300">
                    {content.body1}
                </Text>
            </Row>
            <Row alignItems="center" justifyContent="center" margin="1rem">
                <Text fontSize="T300">
                    {content.body2}
                </Text>
            </Row>
            <Row alignItems="center" justifyContent="center">
                <Button primary onClick={props.onClickSubscribe}>
                    {content.buttonMsg}
                </Button>
            </Row>
        </div>
    );
}
